module.exports = __webpack_public_path__ + "topbgc1.png?061aa9ada2f2bfc68f83d257aa5246ca";